import React, { PureComponent } from 'react';
import { withRouter } from '../../../../common/utils/NavigationWrapper';
import { List as ListIcon, Lens as CircleIcon } from '@mui/icons-material';
import Tile from '../../../../common/components/Tile/Tile';
import TableEnhancedContainer from '../../../../common/components/TableEnhanced/TableEnhancedContainer';
import Constants from '../../../../common/constants/Constants';

const alertIconStyle = {
  width: '1rem',
  height: '1rem',
  marginTop: '6px',
};

const overallAlertIconStyle = {
  width: '1.5rem',
  height: '1.5rem',
  marginTop: '6px',
};

const markupMap = [
  {
    key: 'ConnectionAlert.Level',
    markup: (el, col, elIndex, colIndex) => {
      var style = { ...alertIconStyle };
      style.color = el.ConnectionAlert ? el.ConnectionAlert.Color : Constants.COLORS.NEUTRAL;
      return <CircleIcon key={1} style={style} fill={style.color} />;
    },
  },
  {
    key: 'StatusAlert.Level',
    markup: (el, col, elIndex, colIndex) => {
      var style = { ...alertIconStyle };
      style.color = el.StatusAlert ? el.StatusAlert.Color : Constants.COLORS.NEUTRAL;
      return <CircleIcon key={1} style={style} fill={style.color} />;
    },
  },
  {
    key: 'OverallAlert.Level',
    markup: (el, col, elIndex, colIndex) => {
      var style = { ...overallAlertIconStyle };
      style.color = el.OverallAlert ? el.OverallAlert.Color : Constants.COLORS.NEUTRAL;
      return <CircleIcon key={1} style={style} fill={style.color} />;
    },
  },
];

class InstrumentsList extends PureComponent {
  render() {
    if (!Array.isArray(this.props.display)) {
      return null;
    }

    let tableConfig = this.props.display.find((e) => e.Type === 'Table');
    if (tableConfig === undefined) {
      return null;
    }

    let columnsConfig = tableConfig.Configuration.columnsConfig;
    let title = tableConfig.Name;

    // attach markup callbacks to columnConfig
    markupMap.forEach((markupCallbacks) => {
      columnsConfig.find((e) => e.type === 'markup' && e.key === markupCallbacks.key).markup =
        markupCallbacks.markup;
    });

    return (
      <Tile title={title} TitleIcon={ListIcon} helpTag="dashboard-instrument_list">
        <TableEnhancedContainer
          {...this.props}
          columns={columnsConfig}
          className="InstrumentsListTable"
          enableHideColumns={true}
          enableActionButtons={true}
          onClickRow={this.onClickRow}
          qaTag="instrument-list"
        />
      </Tile>
    );
  }

  onClickRow = (el) => {
    const { navigate } = this.props;
    navigate(`/instrument-details/${el.SerialNumber}`);
  };
}

export default withRouter(InstrumentsList);
